import React from 'react';

interface Props {
  details: any;
  hideTitle?: boolean;
  hideCompanyName?: boolean;
}

interface FormattedTextSectionProps {
  label: string;
  value?: string;
}

const FormattedTextSection: React.FC<FormattedTextSectionProps> = ({ label, value }) => (
  <section className="space-y-2">
    <h3 className="text-sm font-semibold text-zinc-900">{label}</h3>
    <div className="rounded-md border border-slate-200 bg-slate-50 px-4 py-3 text-sm leading-6 text-zinc-800 shadow-inner whitespace-pre-wrap break-words">
      {value?.trim() || 'Not provided.'}
    </div>
  </section>
);

const ClientDetailsCard: React.FC<Props> = ({ details, hideTitle = false, hideCompanyName = false }) => {
  return (
    <div className="border rounded-lg p-6 shadow-sm bg-white">
      {!hideTitle && <h2 className="text-lg font-semibold mb-6">Client Details</h2>}
      <div className="space-y-5 text-sm">
        {!hideCompanyName && (
          <div className="flex">
            <div className="w-32 font-medium text-zinc-900">Company Name:</div>
            <div className="flex-1 text-zinc-900">{details?.name}</div>
          </div>
        )}
        <div className="flex">
          <div className="w-32 font-medium text-zinc-900">Industry:</div>
          <div className="flex-1 text-zinc-900">{details?.industry_type}</div>
        </div>
        <FormattedTextSection label="Company Profile" value={details?.company_profile} />
        <FormattedTextSection label="Our Relationship" value={details?.relationship_summary} />
      </div>
    </div>
  );
};

export default ClientDetailsCard;
